import { ModelBase } from "../abstract/model-base.model";
import { AnalyticalAxis } from "./analytical-axis.model";
import { AnalyticalKeyPart } from "./analytical-key-part.model";

export class AnalyticalKey extends ModelBase {

    static override CLASS_NAME: string = 'AnalyticalKey';

    private _active!: boolean;
    private _axis!: AnalyticalAxis;
    private _label!: string;
    private _parts!: AnalyticalKeyPart[];

    public override toString(): string {
        return this._label;
    }

    public get active(): boolean {
        return this._active;
    }

    public set active(value: any) {
        this._setValue('_active', value, 'boolean');
    }

    public get axis(): AnalyticalAxis {
        return this._axis;
    }

    public set axis(value: any) {
        this._setValue('_axis', value, 'AnalyticalAxis');
    }

    public get label(): string {
        return this._label;
    }

    public set label(value: any) {
        this._setValue('_label', value, 'string');
    }

    public get parts(): AnalyticalKeyPart[] {
        return this._parts;
    }

    public set parts(value: any) {
        this._setValue('_parts', value, 'AnalyticalKeyPart');
    }

    /** Vrai quand la somme des parts vaut exactement 100 %. */
    public get isBalanced(): boolean {
        return Math.abs(this.totalPercentage - 100) < 0.00001;
    }

    /** Résumé des parts pour l'affichage en liste (ex : « 40 / 35 / 25 »). */
    public get partsSummary(): string {
        return (this._parts || []).map(part => Math.round(part.percentage || 0)).join(' / ');
    }

    /** Somme des pourcentages des parts (doit valoir exactement 100 pour être valide). */
    public get totalPercentage(): number {
        return (this._parts || []).reduce((total, part) => total + (part.percentage || 0), 0);
    }
}
